import { ActionReducerMapBuilder, createReducer } from '@reduxjs/toolkit';
import { deleteCard } from '../actions/deleteCard';
import { deletePrimaryCard } from '../actions/deletePrimaryCard';
import { fetchCards } from '../actions/fetchCards';
import { fetchDemoCards } from '../actions/fetchDemoCards';
import { fetchFreeText } from '../actions/fetchFreeText';
import { markCardPrimary } from '../actions/markCardPrimary';
import { fetchRecurringPaymentMethods } from '../actions/fetchRecurringPaymentMethods';
import { resetRequestState } from '../actions/requests';

export interface IRequestStateMeta {
  loading?: boolean;
  success?: boolean;
  error?: any;
  creditCardId?: string;
}
type StateMeta =
  | 'deleteCard'
  | 'fetchCards'
  | 'deletePrimaryCard'
  | 'markCardPrimary'
  | 'fetchFreeText'
  | 'fetchDemoCards'
  | 'fetchRecurringPaymentMethods';

export type IRequestsState = Record<StateMeta, IRequestStateMeta>;

const initialState: IRequestsState = {
  fetchCards: {},
  fetchFreeText: {},
  fetchDemoCards: {},
  deleteCard: {},
  deletePrimaryCard: {},
  markCardPrimary: {},
  fetchRecurringPaymentMethods: {},
};

const actionsByName = {
  fetchCards,
  deleteCard,
  deletePrimaryCard,
  fetchFreeText,
  fetchDemoCards,
  fetchRecurringPaymentMethods,
  markCardPrimary,
};

const createRequestStateReducer = (
  builder: ActionReducerMapBuilder<IRequestsState>,
  requestStateKey: keyof IRequestsState,
) => {
  builder.addCase(actionsByName[requestStateKey].fulfilled, (state, action) => {
    state[requestStateKey] = { success: true, ...(action.meta.arg ? { creditCardId: action.meta.arg as string } : {}) };
  });
  builder.addCase(actionsByName[requestStateKey].pending, (state, action) => {
    state[requestStateKey] = { loading: true, ...(action.meta.arg ? { creditCardId: action.meta.arg as string } : {}) };
  });
  builder.addCase(actionsByName[requestStateKey].rejected, (state, action) => {
    state[requestStateKey] = { error: true, ...(action.meta.arg ? { creditCardId: action.meta.arg as string } : {}) };
  });
};

export const requestsStateReducer = createReducer(initialState, (builder) => {
  createRequestStateReducer(builder, 'fetchCards');
  createRequestStateReducer(builder, 'fetchFreeText');
  createRequestStateReducer(builder, 'fetchDemoCards');
  createRequestStateReducer(builder, 'deleteCard');
  createRequestStateReducer(builder, 'deletePrimaryCard');
  createRequestStateReducer(builder, 'markCardPrimary');
  createRequestStateReducer(builder, 'fetchRecurringPaymentMethods');
  builder.addCase(resetRequestState, (state, action) => {
    state[action.payload] = { error: false };
  });
});
